import { createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35d77e36")

_pushScopeId("data-v-35d77e36")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Edit Incentive Program")
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  class: "label is-inline-flex is-align-items-center is-required",
  for: "incentiveProgram"
}, [
  /*#__PURE__*/_createVNode("span", null, "Incentive Program")
], -1)
const _hoisted_4 = { class: "control is-expanded" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  class: "label",
  for: "editIncentiveProgramComments"
}, " Comments ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "help is-danger" }, "(required)", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_option = _resolveComponent("select-option")
  const _component_field_validate = _resolveComponent("field-validate")
  const _component_modal_dialog = _resolveComponent("modal-dialog")

  return (_openBlock(), _createBlock(_component_modal_dialog, {
    onDone: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resolveDialogAction($event))),
    active: _ctx.isVisible
  }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("form", { id: _ctx.formId }, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", null, [
              _createVNode(_component_select_option, {
                modelValue: _ctx.incentiveProgramEditModel.incentiveProgramId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.incentiveProgramEditModel.incentiveProgramId = $event)),
                "populate-fn": _ctx.getIncentiveProgramsPromise(),
                name: "incentiveProgram",
                "is-required": ""
              }, null, 8, ["modelValue", "populate-fn"]),
              _createVNode(_component_field_validate, {
                for: "incentiveProgram",
                required: ""
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _withDirectives(_createVNode("textarea", {
            placeholder: "Reason of change",
            name: "editIncentiveProgramComments",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.incentiveProgramEditModel.comment = $event))
          }, null, 512), [
            [_vModelText, _ctx.incentiveProgramEditModel.comment]
          ]),
          _createVNode(_component_field_validate, {
            for: "editIncentiveProgramComments",
            required: "",
            "max-length": 250
          })
        ])
      ], 8, ["id"])
    ]),
    _: 1
  }, 8, ["active"]))
})